import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=42754836&scoped=true"
import script from "./Sections.vue?vue&type=script&lang=js"
export * from "./Sections.vue?vue&type=script&lang=js"
import style0 from "./Sections.vue?vue&type=style&index=0&id=42754836&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42754836",
  null
  
)

export default component.exports